import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const COMMUNITY_PAGE_ENABLED_QUERY_KEY = ["feature-flags", "community_page_enabled"] as const;

async function fetchCommunityPageEnabled(): Promise<boolean> {
  const { data, error } = await supabase
    .from("platform_settings")
    .select("value")
    .eq("key", "community_page_enabled")
    .maybeSingle();

  if (error) throw error;
  const raw = data?.value as { value?: boolean } | null;
  return raw?.value === true;
}

/** Whether the CFA Community section is visible (admin-controlled). */
export function useCommunityPageEnabled() {
  return useQuery({
    queryKey: COMMUNITY_PAGE_ENABLED_QUERY_KEY,
    queryFn: fetchCommunityPageEnabled,
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}
